import api from '@/apis/di/payrollItemColumnAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('payrollItemColumn', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_payroll_Item_column',
    field: {
      key: 'payroll_item_column_id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
